import { useEvent } from "shared/lib/useEvent"
import { Floor } from "shared/types/Floor"

import { useUpdateFloor } from "entities/floors/api/useUpdateFloor"

interface UseFloorSortProps {
  projectID: string
  floors: Floor[]
}

export function useFloorSort({ projectID, floors }: UseFloorSortProps) {
  const [updateFloor] = useUpdateFloor()

  const handleFloorSort = useEvent(
    (floorID: string, oldIndex: number, newIndex: number) => {
      const movedFloor = floors[oldIndex]
      if (!movedFloor || movedFloor.id !== floorID) return

      updateFloor({
        projectID,
        parentID: null,
        displayPosition: newIndex,
        floor: {
          id: floorID
        }
      })
    }
  )

  return handleFloorSort
}
